import { useState } from 'react';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { useAppleOAuthSignIn } from './useAppleOAuthSignIn';
import { useAppleLoginNonce } from './useAppleLoginNonce';
import { useLoadAppleAuth } from './useLoadAppleAuth';
import { OAuthButton } from '../oauth/OAuthButton';
import { useLoadAppleScript } from './useLoadAppleScript';
import { isOAuthLoading } from '../oauth/utils/isOAuthLoading';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppleButton = () => {
  const [shouldSignInWithApple, setShouldSignInWithApple] = useState(false);
  const {
    appleNonce
  } = useAppleLoginNonce();
  const isAuthLoading = useSelector(state => isOAuthLoading(state, OAuthProviders.Apple));
  const {
    isAppleScriptLoading
  } = useLoadAppleScript();
  useLoadAppleAuth(appleNonce);
  useAppleOAuthSignIn({
    shouldSignInWithApple,
    setShouldSignInWithApple,
    appleNonce
  });
  const handleOnClick = () => {
    setShouldSignInWithApple(true);
  };
  return /*#__PURE__*/_jsx(OAuthButton, Object.assign({
    isLoading: isAuthLoading || isAppleScriptLoading,
    oauth: OAuthProviders.Apple
  }, appleNonce && {
    onClick: handleOnClick
  }));
};